import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  pdfFileInput: {
    display: 'inline-block',
    background: 'linear-gradient(top, #f9f9f9, #e3e3e3)',
    border: '1px solid #999',
    borderRadius: '3px',
    padding: '5px 12px',
    outline: 'none',
    whiteSpace: 'nowrap',
    webkitUserSelect: ' none',
    cursor: 'pointer',
    textShadow: ' 1px 1px #fff',
    fontSeight: '700',
    fontSize: '10pt',
    marginBottom: '20px',
  },
  helpdeskPicImg:{
    maxWidth: '30px',
    maxHeight: '30px',
  },
  pdfEditorChooseFile: {
    display: 'flex',
    marginBottom: '10px',
    width: '100%',
  },
  chosenFileDiv:{
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '3px',
    display: 'flex',
    margin: 'auto auto auto 20px',
    padding: '5px',
    width: '100%',
  },
  chosenFileNameDiv:{
    margin: 'auto auto auto 10px',
    width: '200px',
  },
  chosenFileSizeDiv:{
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '10px',
    lineHeight: '12px',
  },
  chosenFileNameDivInside:{
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }
}));

export { useStyles };
